import { Checkbox, Tooltip } from '@mui/material';
import images from '../../assets/images';
import './TabsContentHeader.scss';
import { useEffect, useRef, useState } from 'react';


interface propsType {
  title: string;
  subtitle: string;
  addLabel: string;
  setDisplayForm?: (value: boolean) => void;
  displayForm?: boolean;
  handleSearchDebounce?: (value: string) => void;
  setClickAction?: (value: string) => void;
  subImage: string;
  searchValue: string;
  setSearchValue: (value: string) => void;
  tab?: string;
  handleCheckAll?: () => void;
  isSelectAllChecked?: boolean;
  setOpenSwitchClassPopup?: (val: boolean) => void;
  checkedStudents?: string[];
}
const TabsContentHeader = ({ title, subtitle, addLabel, setDisplayForm, displayForm, handleSearchDebounce, setClickAction, subImage, searchValue, setSearchValue, tab, handleCheckAll, isSelectAllChecked, setOpenSwitchClassPopup, checkedStudents }: propsType) => {
  const { searchIcon, plusIcon, backArrow, studentCheckboxAllChecked, studentCheckboxAllOutline, ShareIconStudent } = images;

  const searchOnChange = (event: { target: { value: string; }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounce){
      handleSearchDebounce(event?.target?.value);
    }
  }

  const handleShareButton = () => {
    if (checkedStudents && checkedStudents?.length > 0 && setOpenSwitchClassPopup) {
      setOpenSwitchClassPopup(true);
    }
  }


  const titleRef = useRef<HTMLDivElement | null>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    checkOverflow();
  }, [title]); // Recheck when the title changes

  const checkOverflow = () => {
    if (titleRef.current) {
      setIsOverflow(titleRef.current.scrollWidth > titleRef.current.clientWidth);
    }
  };
  
  return (
    <div className='tabsContentHeader'>
      <div className={subImage === backArrow? 'tabsHeaderLeftContainerBack' : 'tabsHeaderLeftContainer'}>
        {subImage === backArrow ?
        <div className='backImageContainer' onClick={()=>{if(setDisplayForm){setDisplayForm(!displayForm)}}}>
          <img src={subImage} alt='userImage' className='imageStyle' />
        </div> 
      :
        <div className='imageContainer'>
          <img src={subImage} alt='userImage' className='imageStyle' />
        </div>
        }
        <div className='labelContainer'>
        <Tooltip title={title} disableHoverListener={!isOverflow} placement="top">
      <div
        className="titleStyle"
        ref={titleRef}
      >
        {title}
      </div>
    </Tooltip>
          <div className='subTitleStyle'>{subtitle}</div>
        </div>
      </div>
      { (subImage !== backArrow || tab === "student") &&
      <div className='tabHeaderMiddleContainer'>
        <div className='searchIconContainer'><img src={searchIcon} alt='searchIcon' className='searchIconStyle' /></div>
        <input id="searchBox" type='text' onChange={searchOnChange} value={searchValue} placeholder='Search' className='searchInputFieldStyle' />
      </div>
      }
      {addLabel!=="" ?
      <div onClick={() => {
        if (setDisplayForm) {
          setDisplayForm(!displayForm);
        }
        if (setClickAction) {
          setClickAction("add");
        }
      }}
        className='tabHeaderRightContainer'
      >
        <div className='addLabelStyle'>{addLabel}</div>
        <div className='plusIconContainer'>
          <img src={plusIcon} alt="plusIcon" className='plusIconStyle' />
        </div>
      </div>
      : 
      (tab === "student") ? (
        <div className='tabHeaderRightContainer selectContainer'>
          <div className='CheckboxContainer'>
            <div className='selectAllStyle'>Select All</div>
            <Checkbox
                icon={<img src={studentCheckboxAllOutline} alt="Unchecked"/>}
                checkedIcon={<img src={studentCheckboxAllChecked} alt="Checked"/>}
                checked={isSelectAllChecked}
                onChange={handleCheckAll}
            />
          </div>
          {setOpenSwitchClassPopup && (<div className='shareIconContainer' onClick={handleShareButton}>
            <img src={ShareIconStudent} alt="plusIcon" className='shareIconStyle' />
          </div>)}
        </div>
      ) :
      <div className='tabHeaderRightContainerEmpty'>
      </div>}
    </div>
  )
}

export default TabsContentHeader;
